export const GET_DEPENDENTS_QUERY_KEY = ['dependents'] as const;

export const RELATIONSHIP_FIELD_NAME = 'relationship_code';
export const ENROLL_IN_MEDICARE_FIELD_NAME = 'enroll_in_medicare';
export const VERIFIED_FIELD_NAME = 'verified';
export const LIVES_AT_HOME_FIELD_NAME = 'lives_at_home';

export const BASIC_INFORMATION_CATEGORY_NAME = 'Basic Information';
export const OTHER_INFORMATION_CATEGORY_NAME = 'Other';
